import appLogger from "@next-platform/client-common-core/logger/appLogger";

const characterFormLogger = appLogger.withTag("CharacterForm");

export default characterFormLogger;
